import { createAsyncThunk } from '@reduxjs/toolkit';

import * as API from '../api/index.js';

import { formatTeamEvents } from '../utils/calendarHelper.js';
import { fetchAllBirthdays } from './birthdayThunks.js';
import { fetchAllHolidays } from './holidayThunks.js';

export const fetchTeamEvents = createAsyncThunk(
    'calendar/fetchTeamEvents',
    async (_, { getState, rejectWithValue }) => {
        try {
            const teamEvents = await API.user.getTeamEvents();
            const userId = getState().user.user.id;

            if (!userId) {
                return rejectWithValue('User not ready');
            }

            return formatTeamEvents(teamEvents, userId);
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const fetchRemoteCalendar = createAsyncThunk(
    'calendar/fetchRemoteCalendar',
    async (_, { getState, rejectWithValue }) => {
        try {
            const userId = getState().user.user.id;

            if (!userId) {
                return rejectWithValue('User not ready');
            }

            const { calendarKey } = await API.user.getRemoteCalendar(userId);
            return calendarKey;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const fetchPermissionToCreateUserEvents = createAsyncThunk(
    'calendar/fetchPermissionToCreateUserEvents',
    async (_, { rejectWithValue }) => {
        try {
            const enabled = await API.user.getPermissionToCreateEvents();
            return enabled;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    },
);

export const fetchCalendarData = createAsyncThunk('calendar/fetchCalendarData', async (_, { dispatch }) => {
    await Promise.all([dispatch(fetchTeamEvents()), dispatch(fetchAllHolidays()), dispatch(fetchAllBirthdays())]);
});
